import React, { Suspense, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../components/Footer";

const Home = ({ selectedSection }) => {
  const location = useLocation();
    const contactUsRef = useRef(null);
    const [form, setForm] = useState({
       name: "",
       email: "",
       mobile: "",
       message: "",
     });
      const [submitting, setSubmitting] = useState(false);
     const [feedback, setFeedback] = useState(null);
 const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };
   const handleSubmit = async (e) => {
  e.preventDefault();
  setFeedback(null);

  if (!form.name || !form.email || !form.mobile || !form.message) {
    setFeedback({ type: "danger", msg: "All fields are required." });
    return;
  }

  setSubmitting(true);
  try {
    const payload = {
      name: form.name,
      email: form.email,
      mobile_number: form.mobile, // Change is here!
      message: form.message,
    };

    const response = await fetch("https://web1024.docmaster.in:5000/api/contact-legal", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error("Failed to submit. Please try again.");
    }

    setFeedback({ type: "success", msg: "Thank you! Your message has been sent." });
    setForm({ name: "", email: "", mobile: "", message: "" });
  } catch (err) {
    setFeedback({ type: "danger", msg: err.message });
  } finally {
    setSubmitting(false);
  }
};
  // Only clicks an accordion button if its target panel is currently collapsed (i.e. closed).
  // This prevents the double-click effect where a click opens then immediately closes.
  const openAccordion = (buttonId) => {
    const btn = document.getElementById(buttonId);
    if (!btn) return;
    const targetId = btn.getAttribute("data-bs-target")?.replace("#", "");
    const panel = targetId ? document.getElementById(targetId) : null;
    const isCollapsed = panel ? !panel.classList.contains("show") : btn.classList.contains("collapsed");
    if (isCollapsed) btn.click();
  };

  useEffect(() => {
    switch (location.hash) {
      case "#aboutus": {
        openAccordion("about-us");
        break;
      }
      case "#faq": {
        openAccordion("faq-el");
        break;
      }
      case "#Contact": {
        openAccordion("contact-us-el");
        break;
      }
      case "#Disclaimer": {
        openAccordion("disclimer-el");
        openAccordion("ourpolicy-el");
        break;
      }
      case "#TearmsConditions": {
        openAccordion("tearmsConditions-el");
        openAccordion("ourpolicy-el");
        break;
      }
      case "#PrivacyPolicy": {
        openAccordion("privacyPolicy-el");
        openAccordion("ourpolicy-el");
        break;
      }
      case "#CPolicy": {
        openAccordion("cpolicy-el");
        openAccordion("ourpolicy-el");
        break;
      }
      case "#PricingPlan": {
        openAccordion("pricingPlan-el");
        break;
      }
      case "#Ipr": {
        openAccordion("ipr-el");
        openAccordion("ourpolicy-el");
        break;
      }
      default: {
        openAccordion("about-us");
      }
    }
  }, [location]);

  

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({});
    // ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  // State to control the position (left: 0 or left: 250)
  const [isOpen, setIsOpen] = useState(true);

  // Function to toggle the position
  const togglePosition = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Suspense fallback={<>Loading...</>}>
      <div className="main_container mt-5">
        <div className=" ">
          <div class="d-flex w-100 py-2">
            <div
              class=" w-100  d-flex flex-column  home-right-col justify-content-between"
              style={{ height: "91vh", overflowY: "auto" }}
            >
              <div className="w-100 flex-1">
                {/* About Us section */}
                <section
                  style={{ width: "100%", position: "fixed", top: "0" }}
                  id="about-us-section"
                  className="about-us-section  "
                >
                  <nav class="navbar navbar-light bg-white px-5">
                    <div class="container-fluid px-0">
                      <a href="/" class="navbar-brand">
                        <img
                          src="/images/docmasterLogo.png"
                          alt="Logo"
                          className="logo img-fluid"
                          style={{ width: "180px",  }}
                        />
                      </a>
                      <div class=" gap-4 d-flex align-content-center flex-wrap">
                        <a
                          href="/"
                          class=" py-1 text-decoration-none text-dark"
                        >
                          Login
                        </a>
                        <a
                          href="/registration"
                          class="btn m-0 btn-sm bg-primary text-white btn-sm ps-3"
                          type="submit"
                        >
                          Sign Up Free
                        </a>
                      </div>
                    </div>
                  </nav>
                </section>
                <div
                  class="accordion accordion-flush"
                  id="accordionHomePage"
                  style={{ width: "80%", margin: "auto" }}
                >
                  <div class="accordion-item" >
                    <h2 class="accordion-header" id="flush-headingAbout">
                      <button
                        class="accordion-button bg-primary text-white"
                        id="about-us"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseAbout"
                        aria-expanded="false"
                        aria-controls="flush-collapseAbout"
                      >
                        <strong className="p-3">About Us</strong>
                      </button>
                    </h2>
                    <div
                      id="flush-collapseAbout"
                      class="accordion-collapse collapse show text-black accordian-shadow"
                      aria-labelledby="flush-headingAbout"
                      data-bs-parent="#accordionHomePage"
                    >
                      <div class="accordion-body p-4" style={{background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'}}>
                        <div className="card border-0 shadow-lg rounded-4 mb-4">
                          <div className="card-body p-4">
                            <div className="row align-items-center mb-4">
                              <div className="col-lg-8">
                                <h3 className="fw-bold text-dark mb-3">Welcome to MyDocMaster</h3>
                                <p className="text-16 text-dark mb-0 lh-lg">
                                  <a href="mydocMaster.com" className="text-decoration-none fw-semibold" style={{color: '#667eea'}}>MyDocMaster.com</a> is a specialised school module developed under the DocMaster community, designed to streamline administrative workflows for any educational institutions. While the <a href="DocMaster.in" target="_blank" className="text-decoration-none fw-semibold" style={{color: '#667eea'}}>DocMaster.in</a> cater to legal, civic, and many professional and personal domains, <a href="mydocMaster.com" className="text-decoration-none fw-semibold" style={{color: '#667eea'}}>MyDocMaster.com</a> focuses specifically on schools, offering a suite of digital tools that streamline academic planning, documentation, and event coordination.
                                </p>
                              </div>
                              <div className="col-lg-4 text-center d-none d-lg-block">
                                <div className="rounded-circle mx-auto d-flex align-items-center justify-content-center"
                                     style={{width: '150px', height: '150px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'}}>
                                  <i className="bi bi-mortarboard-fill text-white" style={{fontSize: '4rem'}}></i>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <h4 className="fw-bold text-dark mb-4 text-center">Key Products & Features</h4>

                        <div className="row g-4 mb-4">
                          <div className="col-md-6">
                            <div className="card h-100 border-0 shadow-sm rounded-3 hover-lift" style={{transition: 'all 0.3s'}}>
                              <div className="card-body p-4">
                                <div className="d-flex align-items-start">
                                  <div className="flex-shrink-0">
                                    <div className="rounded-3 d-flex align-items-center justify-content-center"
                                         style={{width: '50px', height: '50px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'}}>
                                      <i className="bi bi-calendar3 text-white fs-4"></i>
                                    </div>
                                  </div>
                                  <div className="flex-grow-1 ms-3">
                                    <h5 className="fw-bold text-dark mb-2">Time Table Generator</h5>
                                    <p className="text-muted mb-0 small">A flexible fully automated tool for creating class schedules across grades, subjects, and teachers— ideal for schools managing multiple shifts or custom timetables.</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="card h-100 border-0 shadow-sm rounded-3 hover-lift" style={{transition: 'all 0.3s'}}>
                              <div className="card-body p-4">
                                <div className="d-flex align-items-start">
                                  <div className="flex-shrink-0">
                                    <div className="rounded-3 d-flex align-items-center justify-content-center"
                                         style={{width: '50px', height: '50px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'}}>
                                      <i className="bi bi-file-text text-white fs-4"></i>
                                    </div>
                                  </div>
                                  <div className="flex-grow-1 ms-3">
                                    <h5 className="fw-bold text-dark mb-2">Question Paper Builder</h5>
                                    <p className="text-muted mb-0 small">Enables educators to design structured, syllabus-aligned question papers with customizable formats, difficulty levels and variety of questions in one go.</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="card h-100 border-0 shadow-sm rounded-3 hover-lift" style={{transition: 'all 0.3s'}}>
                              <div className="card-body p-4">
                                <div className="d-flex align-items-start">
                                  <div className="flex-shrink-0">
                                    <div className="rounded-3 d-flex align-items-center justify-content-center"
                                         style={{width: '50px', height: '50px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'}}>
                                      <i className="bi bi-calendar-event text-white fs-4"></i>
                                    </div>
                                  </div>
                                  <div className="flex-grow-1 ms-3">
                                    <h5 className="fw-bold text-dark mb-2">Event Organiser</h5>
                                    <p className="text-muted mb-0 small">It starts from simplifying planning for school functions, awareness drives, competitions, and campaigns, complete with task lists, budgeting, quotation summaries and much more at one place.</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="card h-100 border-0 shadow-sm rounded-3 hover-lift" style={{transition: 'all 0.3s'}}>
                              <div className="card-body p-4">
                                <div className="d-flex align-items-start">
                                  <div className="flex-shrink-0">
                                    <div className="rounded-3 d-flex align-items-center justify-content-center"
                                         style={{width: '50px', height: '50px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'}}>
                                      <i className="bi bi-journal-check text-white fs-4"></i>
                                    </div>
                                  </div>
                                  <div className="flex-grow-1 ms-3">
                                    <h5 className="fw-bold text-dark mb-2">Teacher Planner</h5>
                                    <p className="text-muted mb-0 small">A personal dashboard for educators to manage not only the lesson plans to complete their syllabus in the given time but frame all activities assigned to it at one place.</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="card h-100 border-0 shadow-sm rounded-3 hover-lift" style={{transition: 'all 0.3s'}}>
                              <div className="card-body p-4">
                                <div className="d-flex align-items-start">
                                  <div className="flex-shrink-0">
                                    <div className="rounded-3 d-flex align-items-center justify-content-center"
                                         style={{width: '50px', height: '50px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'}}>
                                      <i className="bi bi-calendar2-check text-white fs-4"></i>
                                    </div>
                                  </div>
                                  <div className="flex-grow-1 ms-3">
                                    <h5 className="fw-bold text-dark mb-2">Academic Calendar</h5>
                                    <p className="text-muted mb-0 small">It allows institutions to automatically create and map the entire school year. It includes holidays, exams, campaigns, PTM, and awareness drives into a well structured, shareable format.</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="card h-100 border-0 shadow-sm rounded-3 hover-lift" style={{transition: 'all 0.3s'}}>
                              <div className="card-body p-4">
                                <div className="d-flex align-items-start">
                                  <div className="flex-shrink-0">
                                    <div className="rounded-3 d-flex align-items-center justify-content-center"
                                         style={{width: '50px', height: '50px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'}}>
                                      <i className="bi bi-file-earmark-richtext text-white fs-4"></i>
                                    </div>
                                  </div>
                                  <div className="flex-grow-1 ms-3">
                                    <h5 className="fw-bold text-dark mb-2">Documents Module</h5>
                                    <p className="text-muted mb-0 small">Allows quick creations of most of the documents like letters, certificates, admission forms, HR letters, PoSH compliance, and more—many of which can be completed with minimal human intervention.</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="card border-0 shadow-lg rounded-4" style={{background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'}}>
                          <div className="card-body p-4 text-white">
                            <div className="d-flex align-items-center">
                              <div className="flex-shrink-0 me-3">
                                <i className="bi bi-lightbulb-fill" style={{fontSize: '3rem'}}></i>
                              </div>
                              <div className="flex-grow-1">
                                <p className="mb-0 lh-lg">
                                  This platform empowers schools to modernise their operations by digitising key academic and administrative workflows into intuitive, bilingual modules. Whether it's preparing for awareness drives, managing school visits, or generating campaign-ready materials, the platform acts as a reliable backend engine that supports both day-to-day functioning and long-term outreach goals.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div class="accordion-item"  >
                    <h2 class="accordion-header" id="flush-headingPricing">
                      <button
                        class="accordion-button collapsed bg-primary text-white p-0"
                        type="button"
                        id="pricingPlan-el"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapsePricing"
                        aria-expanded="false"
                        aria-controls="flush-collapsePricing"
                      >
                        <strong>Pricing Plan</strong>
                      </button>
                    </h2>
                    <div
                      id="flush-collapsePricing"
                      class="accordion-collapse collapse accordian-shadow"
                      aria-labelledby="flush-headingPricing"
                      data-bs-parent="#accordionHomePage"
                    >
                      <div class="accordion-body p-0">
                        <PricingComponent />
                      </div>
                    </div>
                  </div> */}

                  {/* <div class="accordion-item" >
                    <h2 class="accordion-header" id="flush-headingFaq">
                      <button
                        class="accordion-button collapsed bg-primary text-white p-0"
                        type="button"
                        id="faq-el"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseFaq"
                        aria-expanded="false"
                        aria-controls="flush-collapseFaq"
                      >
                        <strong>FAQ's | Frequently Asked Questions</strong>
                      </button>
                    </h2>
                    <div
                      id="flush-collapseFaq"
                      class="accordion-collapse collapse accordian-shadow"
                      aria-labelledby="flush-headingFaq"
                      data-bs-parent="#accordionHomePage"
                    >
                      <div class="accordion-body p-2">
                        <div
                          class="accordion accordion-flush"
                          id="accordionFlushExample"
                        >
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingOne">
                              <button
                                class="accordion-button border collapsed bg-secondary-acc text-black"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseOne"
                                aria-expanded="false"
                                aria-controls="flush-collapseOne"
                              >
                                <strong>Q. </strong> What are the services
                                offered by Docmaster.Legal?
                              </button>
                            </h2>
                            <div
                              id="flush-collapseOne"
                              class="accordion-collapse collapse accordian-shadow"
                              aria-labelledby="flush-headingOne"
                              data-bs-parent="#accordionFlushExample"
                            >
                              <div class="accordion-body">
                                <strong>A.</strong> Docmaster modules help
                                execution of different tasks one needed in
                                day-to-day life. It’s All in One Legal Module
                                for Advocates offer multiple options any
                                advocate requires like Client Meeting, Research,
                                Automated Drafting, Judgement Search, Online
                                filing, Case hearing diary and Document
                                management. It helps saving time at every place
                                besides help keep track of activity. This tool
                                supports legal professionals from the very first
                                point, the initial client discussion and remains
                                a 24/7 assistant throughout the litigation
                                process. It is all in one management system that
                                manages all legal and procedural aspects in one
                                go without errors.
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingTwo">
                              <button
                                class="accordion-button collapsed bg-secondary-acc p-0 text-black"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseTwo"
                                aria-expanded="false"
                                aria-controls="flush-collapseTwo"
                              >
                                <strong>Q. </strong>Does Docmaster.Legal offer
                                legal advice?
                              </button>
                            </h2>
                            <div
                              id="flush-collapseTwo"
                              class="accordion-collapse collapse accordian-shadow"
                              aria-labelledby="flush-headingTwo"
                              data-bs-parent="#accordionFlushExample"
                            >
                              <div class="accordion-body">
                                <strong>A.</strong> DocMaster does not offer any
                                Legal advice.
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2
                              class="accordion-header"
                              id="flush-headingThree"
                            >
                              <button
                                class="accordion-button collapsed bg-secondary-acc p-0 text-black"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseThree"
                                aria-expanded="false"
                                aria-controls="flush-collapseThree"
                              >
                                <strong>Q. </strong> Who all can use this
                                website?
                              </button>
                            </h2>
                            <div
                              id="flush-collapseThree"
                              class="accordion-collapse collapse accordian-shadow"
                              aria-labelledby="flush-headingThree"
                              data-bs-parent="#accordionFlushExample"
                            >
                              <div class="accordion-body">
                                <strong>A.</strong> Docmaster has domain
                                specific module for the use of professionals,
                                individuals and businesses. DocMaster.Legal is
                                being developed for the advocates engage in
                                litigations in courts.
                              </div>
                            </div>
                          </div>

                          <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingFour">
                              <button
                                class="accordion-button collapsed bg-secondary-acc p-0 text-black"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseFour"
                                aria-expanded="false"
                                aria-controls="flush-collapseFour"
                              >
                                <strong>Q. </strong> What is the use of Client
                                Management?
                              </button>
                            </h2>
                            <div
                              id="flush-collapseFour"
                              class="accordion-collapse collapse accordian-shadow"
                              aria-labelledby="flush-headingFour"
                              data-bs-parent="#accordionFlushExample"
                            >
                              <div class="accordion-body">
                                <strong>A.</strong> In DocMaster.Legal the user
                                (an Advocate) can record, manage and update all
                                information of a client at one place.
                              </div>
                            </div>
                          </div>

                          <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingFive">
                              <button
                                class="accordion-button collapsed bg-secondary-acc p-0 text-black"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseFive"
                                aria-expanded="false"
                                aria-controls="flush-collapseFive"
                              >
                                <strong>Q. </strong> What is the use of Case
                                Management?
                              </button>
                            </h2>
                            <div
                              id="flush-collapseFive"
                              class="accordion-collapse collapse accordian-shadow"
                              aria-labelledby="flush-headingFive"
                              data-bs-parent="#accordionFlushExample"
                            >
                              <div class="accordion-body">
                                <strong>A.</strong> In DocMaster.Legal the user
                                (an Advocate) can manage and update cases
                                related to clients at one place. Can also create
                                and view all the cases of clients at a glance.
                              </div>
                            </div>
                          </div>

                          <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingSix">
                              <button
                                class="accordion-button collapsed bg-secondary-acc p-0 text-black"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseSix"
                                aria-expanded="false"
                                aria-controls="flush-collapseSix"
                              >
                                <strong>Q. </strong> Is it a paid service?
                              </button>
                            </h2>
                            <div
                              id="flush-collapseSix"
                              class="accordion-collapse collapse accordian-shadow"
                              aria-labelledby="flush-headingSix"
                              data-bs-parent="#accordionFlushExample"
                            >
                              <div class="accordion-body">
                                <strong>A.</strong> Yes. it is a paid annual
                                subscription-based module. To know more visit{" "}
                                <a href="/About#PricingPlan">
                                  <u>Pricing Plans</u>
                                </a>{" "}
                                choose one best suited your requirements. We
                                also offer 45 days free trail.
                              </div>
                            </div>
                          </div>

                          <div class="accordion-item">
                            <h2
                              class="accordion-header"
                              id="flush-headingSeven"
                            >
                              <button
                                class="accordion-button collapsed bg-secondary-acc p-0 text-black"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseSeven"
                                aria-expanded="false"
                                aria-controls="flush-collapseSeven"
                              >
                                <strong>Q. </strong> Is there any free trial
                                period?
                              </button>
                            </h2>
                            <div
                              id="flush-collapseSeven"
                              class="accordion-collapse collapse accordian-shadow"
                              aria-labelledby="flush-headingSeven"
                              data-bs-parent="#accordionFlushExample"
                            >
                              <div class="accordion-body">
                                <strong>A.</strong> Yes, we offer 45 days free
                                trial.
                              </div>
                            </div>
                          </div>

                          <div class="accordion-item">
                            <h2
                              class="accordion-header"
                              id="flush-headingEight"
                            >
                              <button
                                class="accordion-button collapsed bg-secondary-acc p-0 text-black"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseEight"
                                aria-expanded="false"
                                aria-controls="flush-collapseEight"
                              >
                                <strong>Q. </strong> How can I subscribe for
                                Docmaster.Legal?
                              </button>
                            </h2>
                            <div
                              id="flush-collapseEight"
                              class="accordion-collapse collapse accordian-shadow"
                              aria-labelledby="flush-headingEight"
                              data-bs-parent="#accordionFlushExample"
                            >
                              <div class="accordion-body">
                                <strong>A.</strong> Visit the website, submit
                                the required details and get registered.
                              </div>
                            </div>
                          </div>

                          <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingNine">
                              <button
                                class="accordion-button collapsed bg-secondary-acc p-0 text-black"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseNine"
                                aria-expanded="false"
                                aria-controls="flush-collapseNine"
                              >
                                <strong>Q. </strong> If I wish to cancel my
                                subscription, will I be entitled for any refund?
                              </button>
                            </h2>
                            <div
                              id="flush-collapseNine"
                              class="accordion-collapse collapse accordian-shadow"
                              aria-labelledby="flush-headingNine"
                              data-bs-parent="#accordionFlushExample"
                            >
                              <div class="accordion-body">
                                <strong>A.</strong> DocMaster does not have a
                                refund policy. We give a free version to
                                experience the quality of our services before
                                any subscription to all the users.
                              </div>
                            </div>
                          </div>

                          <div class="accordion-item">
                            <h2 class="accordion-header" id="flush-headingten">
                              <button
                                class="accordion-button collapsed bg-secondary-acc p-0 text-black"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseTen"
                                aria-expanded="false"
                                aria-controls="flush-collapseTen"
                              >
                                <strong>Q. </strong> Is the information I submit
                                kept confidential?
                              </button>
                            </h2>
                            <div
                              id="flush-collapseTen"
                              class="accordion-collapse collapse accordian-shadow"
                              aria-labelledby="flush-headingten"
                              data-bs-parent="#accordionFlushExample"
                            >
                              <div class="accordion-body">
                                <strong>A.</strong> All the information saved on
                                our server is in encrypted form only. Most
                                importantly it is only accessible to the user.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingContact">
                      <button
                        class="accordion-button collapsed bg-primary text-white p-0"
                        type="button"
                        id="contact-us-el"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseContact"
                        aria-expanded="false"
                        aria-controls="flush-collapseContact"
                      >
                        <strong className="p-3">Contact Us</strong>
                      </button>
                    </h2>
                    <div
                      id="flush-collapseContact"
                      class="accordion-collapse collapse accordian-shadow"
                      aria-labelledby="flush-headingContact"
                      data-bs-parent="#accordionHomePage"
                    >
                      <div class="accordion-body p-3 p-md-5" style={{background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', minHeight: '600px'}}>
                        <div className="container-fluid px-0 px-md-3">
                          <div class="text-center mb-4 mb-md-5">
                            <h2 class="display-6 display-md-5 fw-bold text-white mb-3">Get in Touch</h2>
                            <p class="text-white opacity-90 px-2" style={{fontSize: '0.95rem'}}>We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
                          </div>

                          <div class="row justify-content-center g-4 g-lg-5" style={{columnGap: '3rem'}}>
                            <div class="col-12 col-lg-4">
                              <div class="card border-0 rounded-4 shadow-lg h-100" style={{userSelect: 'none', WebkitUserSelect: 'none', MozUserSelect: 'none', msUserSelect: 'none'}}>
                                <div class="card-body p-3 p-md-4">
                                  <h4 class="fw-bold mb-3 mb-md-4 text-dark" style={{fontSize: '1.15rem'}}>Contact Information</h4>

                                  <div class="d-flex align-items-center mb-3 mb-md-4 p-2 p-md-3 rounded-3"
                                       style={{backgroundColor: '#f8f9fa', transition: 'all 0.3s'}}
                                       onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e9ecef'}
                                       onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}>
                                    <div class="flex-shrink-0">
                                      <div class="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                           style={{width: '45px', height: '45px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'}}>
                                        <i class="bi bi-telephone-fill text-white" style={{fontSize: '1rem'}}></i>
                                      </div>
                                    </div>
                                    <div class="flex-grow-1 ms-2 ms-md-3">
                                      <h6 class="fw-bold mb-1 text-dark" style={{fontSize: '0.9rem'}}>Phone</h6>
                                      <a href="tel:+919289440049" class="text-decoration-none text-muted" style={{fontSize: '0.85rem'}}>+91 92894 40049</a>
                                    </div>
                                  </div>

                                  <div class="d-flex align-items-center mb-3 mb-md-4 p-2 p-md-3 rounded-3"
                                       style={{backgroundColor: '#f8f9fa', transition: 'all 0.3s'}}
                                       onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e9ecef'}
                                       onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}>
                                    <div class="flex-shrink-0">
                                      <div class="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                           style={{width: '45px', height: '45px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'}}>
                                        <i class="bi bi-envelope-fill text-white" style={{fontSize: '1rem'}}></i>
                                      </div>
                                    </div>
                                    <div class="flex-grow-1 ms-2 ms-md-3">
                                      <h6 class="fw-bold mb-1 text-dark" style={{fontSize: '0.9rem'}}>Email</h6>
                                      <a href="mailto:info@mydocmaster.com" class="text-decoration-none text-muted" style={{fontSize: '0.85rem', wordBreak: 'break-word'}}>info@mydocmaster.com</a>
                                    </div>
                                  </div>

                                  <div class="d-flex align-items-center mb-3 mb-md-4 p-2 p-md-3 rounded-3"
                                       style={{backgroundColor: '#f8f9fa', transition: 'all 0.3s'}}
                                       onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e9ecef'}
                                       onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}>
                                    <div class="flex-shrink-0">
                                      <div class="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                           style={{width: '45px', height: '45px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'}}>
                                        <i class="bi bi-clock-fill text-white" style={{fontSize: '1rem'}}></i>
                                      </div>
                                    </div>
                                    <div class="flex-grow-1 ms-2 ms-md-3">
                                      <h6 class="fw-bold mb-1 text-dark" style={{fontSize: '0.9rem'}}>Business Hours</h6>
                                      <p class="mb-0 text-muted" style={{fontSize: '0.85rem'}}>Mon - Sat : 9:00 AM - 6:00 PM</p>
                                    </div>
                                  </div>

                                  <div class="d-flex align-items-start p-2 p-md-3 rounded-3"
                                       style={{backgroundColor: '#f8f9fa', transition: 'all 0.3s'}}
                                       onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e9ecef'}
                                       onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}>
                                    <div class="flex-shrink-0">
                                      <div class="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                           style={{width: '45px', height: '45px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'}}>
                                        <i class="bi bi-geo-alt-fill text-white" style={{fontSize: '1rem'}}></i>
                                      </div>
                                    </div>
                                    <div class="flex-grow-1 ms-2 ms-md-3">
                                      <h6 class="fw-bold mb-1 text-dark" style={{fontSize: '0.9rem'}}>Address</h6>
                                      <p class="mb-0 text-muted" style={{fontSize: '0.85rem'}}>DocMaster<br/>
                                      A 75 Sector 63 Noida - 201301<br/>
                                      Uttar Pradesh, India</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="col-12 col-lg-4">
                              <div class="card border-0 rounded-4 shadow-lg h-100">
                                <div class="card-body p-3 p-md-4">
                                  <h4 class="fw-bold mb-3 mb-md-4 text-dark" style={{fontSize: '1.15rem'}}>Send us a Message</h4>
                                  <form onSubmit={handleSubmit}>
                                    <div className="mb-2 mb-md-3">
                                      <label htmlFor="name" className="form-label fw-semibold text-dark small">
                                        Name <span class="text-danger">*</span>
                                      </label>
                                      <div className="input-group input-group-sm">
                                        <span className="input-group-text border-end-0 bg-white">
                                          <i className="bi bi-person-fill text-muted" style={{fontSize: '0.9rem'}}></i>
                                        </span>
                                        <input
                                          name="name"
                                          type="text"
                                          className="form-control border-start-0 ps-0"
                                          id="name"
                                          placeholder="Enter your full name"
                                          value={form.name}
                                          onChange={handleChange}
                                          disabled={submitting}
                                          required
                                          style={{fontSize: '0.9rem'}}
                                        />
                                      </div>
                                    </div>

                                    <div className="mb-2 mb-md-3">
                                      <label htmlFor="email" className="form-label fw-semibold text-dark small">
                                        Email <span class="text-danger">*</span>
                                      </label>
                                      <div className="input-group input-group-sm">
                                        <span className="input-group-text border-end-0 bg-white">
                                          <i className="bi bi-envelope-fill text-muted" style={{fontSize: '0.9rem'}}></i>
                                        </span>
                                        <input
                                          name="email"
                                          type="email"
                                          className="form-control border-start-0 ps-0"
                                          id="email"
                                          placeholder="your@email.com"
                                          value={form.email}
                                          onChange={handleChange}
                                          disabled={submitting}
                                          required
                                          style={{fontSize: '0.9rem'}}
                                        />
                                      </div>
                                    </div>

                                    <div className="mb-2 mb-md-3">
                                      <label htmlFor="mobile" className="form-label fw-semibold text-dark small">
                                        Mobile <span class="text-danger">*</span>
                                      </label>
                                      <div className="input-group input-group-sm">
                                        <span className="input-group-text border-end-0 bg-white">
                                          <i className="bi bi-phone-fill text-muted" style={{fontSize: '0.9rem'}}></i>
                                        </span>
                                        <input
                                          name="mobile"
                                          type="tel"
                                          className="form-control border-start-0 ps-0"
                                          id="mobile"
                                          placeholder="+91 XXXXX XXXXX"
                                          value={form.mobile}
                                          onChange={handleChange}
                                          disabled={submitting}
                                          required
                                          style={{fontSize: '0.9rem'}}
                                        />
                                      </div>
                                    </div>

                                    <div className="mb-2 mb-md-3">
                                      <label htmlFor="floatingTextarea" className="form-label fw-semibold text-dark small">
                                        Message <span class="text-danger">*</span>
                                      </label>
                                      <textarea
                                        name="message"
                                        className="form-control form-control-sm"
                                        id="floatingTextarea"
                                        rows="4"
                                        placeholder="Tell us how we can help you..."
                                        value={form.message}
                                        onChange={handleChange}
                                        disabled={submitting}
                                        required
                                        style={{fontSize: '0.9rem'}}
                                      ></textarea>
                                    </div>

                                    {feedback && (
                                      <div className={`alert alert-${feedback.type} rounded-3 d-flex align-items-center py-2`} style={{fontSize: '0.85rem'}}>
                                        <i className={`bi ${feedback.type === 'success' ? 'bi-check-circle-fill' : 'bi-exclamation-triangle-fill'} me-2`}></i>
                                        {feedback.msg}
                                      </div>
                                    )}

                                    <div className="d-grid">
                                      <button
                                        type="submit"
                                        className="btn text-white fw-bold rounded-3 shadow-sm py-2 py-md-3"
                                        disabled={submitting}
                                        style={{
                                          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                          transition: 'all 0.3s',
                                          border: 'none',
                                          fontSize: '0.95rem'
                                        }}
                                        onMouseOver={(e) => {
                                          e.target.style.transform = 'translateY(-2px)';
                                          e.target.style.boxShadow = '0 8px 20px rgba(102, 126, 234, 0.4)';
                                        }}
                                        onMouseOut={(e) => {
                                          e.target.style.transform = 'translateY(0)';
                                          e.target.style.boxShadow = '';
                                        }}
                                      >
                                        {submitting ? (
                                          <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Submitting...
                                          </>
                                        ) : (
                                          <>
                                            <i className="bi bi-send-fill me-2"></i>Send Message
                                          </>
                                        )}
                                      </button>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item" >
                    <h2 class="accordion-header" id="flush-headingpolicies">
                      <button
                        class="accordion-button collapsed bg-primary text-white p-0"
                        type="button"
                        id="ourpolicy-el"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapsepolicies"
                        aria-expanded="false"
                        aria-controls="flush-collapsepolicies"
                      >
                        <strong className="p-3">Our Policies</strong>
                      </button>
                    </h2>
                    <div
                      id="flush-collapsepolicies"
                      class="accordion-collapse collapse accordian-shadow"
                      aria-labelledby="flush-headingpolicies"
                      data-bs-parent="#accordionHomePage"
                    >
                      <div class="accordion-body p-2">
                        <div
                          class="accordion accordion-flush"
                          id="accordionplos"
                        >
                          <div class="accordion-item">
                            <h2
                              class="accordion-header"
                              id="flush-headingDesclimer"
                            >
                              <button
                                class="accordion-button collapsed bg-secondary-acc p-0 text-black"
                                type="button"
                                id="disclimer-el"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseDesclimer"
                                aria-expanded="false"
                                aria-controls="flush-collapseDesclimer"
                              >
                                <strong className="p-3">Disclaimer</strong>
                              </button>
                            </h2>
                            <div
                              id="flush-collapseDesclimer"
                              class="accordion-collapse h-100 collapse accordian-shadow"
                              aria-labelledby="flush-headingDesclimer"
                              data-bs-parent="#accordionplos"
                            >
                              <div class="accordion-body p-2">
                                <p className="text-15 text-black text-justify"><a href="mydocmaster.com" >Mydocmaster.com</a> is designed to assist educational institutions in digitising their academic and administrative workflows. The platform consists of tools such as Timetable Generator, Question Paper Builder,Academic Calendar, Teacher planner, Event Organizer, and document templates to streamline school operations.</p>

                               <p className="text-15 text-black text-justify"> While every effort is made to ensure the accuracy, relevance, and usability of the templates and tools available, <a href="mydocMaster.com" >MyDocMaster.com</a> does not guarantee compliance with specific state, national, or institutional education policies. Schools and users are solely responsible for reviewing, customising, and validating all generated content before their final or official use. The platform is not liable for any discrepancies, omissions, or outcomes resulting from the use of its services.</p>

                                <p className="text-15 text-black text-justify"><a href="mydocmaster.com" >Mydocmaster.com</a> does not permanently store personal data entered during document creation. All user inputs are processed securely and retained only for the duration necessary to generate the requested output. Users are advised to download and manage their documents responsibly.</p>

                                <p className="text-15 text-black text-justify">By accessing and using the <a href="mydocMaster.com" >MyDocMaster.com</a>, users acknowledge that they understand and accept the limitations of the platform. They agree to use the tools in accordance with their own institutional guidelines and bear full responsibility for the final application of any content produced.</p>

                                <p className="text-15 text-black text-justify">All resources, data, content and documents made available on this website are intended for general use and operational convenience, and do not constitute legal, regulatory or pedagogical advice in any manner.</p>
                                 
                              </div>
                            </div>
                          </div>

                          <div class="accordion-item" >
                            <h2
                              class="accordion-header"
                              id="flush-headingterms"
                            >
                              <button
                                class="accordion-button collapsed bg-secondary-acc p-0 text-black"
                                type="button"
                                id="tearmsConditions-el"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseTerms"
                                aria-expanded="false"
                                aria-controls="flush-collapseTerms"
                              >
                                <strong className="p-3">Terms and Conditions</strong>
                              </button>
                            </h2>
                            <div
                              id="flush-collapseTerms"
                              class="accordion-collapse collapse accordian-shadow"
                              aria-labelledby="flush-headingterms"
                              data-bs-parent="#accordionplos"
                            >
                              <div class="accordion-body p-2">
                                <p className="text-15 text-black text-justify"><strong>License and Access</strong> - DocMaster allows you a limited access to use its website subject to the terms and conditions mentioned on it, or as applicable and modified from time to time.</p>

                                <p className="text-15 text-black text-justify">The website and any portion of it should not be reproduced, duplicated, copied, downloaded, sold, resold, or otherwise exploited for any commercial purpose without the express written consent of DocMaster. Any unauthorised use may be liable for termination of the services extended by the DocMaster.</p>

                                <p className="text-15 text-black text-justify"><strong>Limitation of Liability</strong> - The website is for use "As is" and "As available" basis. DocMaster also makes, no representations or warranties of any kind, express or implied or otherwise stated, as to the operation of this site, or the information, content or materials included on this site. You expressly agree that your use of this site is at your sole choice and discretion.</p>

                                <p className="text-15 text-black text-justify"><strong>Allowable usage</strong> - You agree to use the services of DocMaster for lawful, personal or professional use of yourself or for particular business and client (as the case may be) only, and not for any prohibited purposes. Prohibited purposes include but shall not be limited to harass abuse or threaten any other persons, Violate any person’s legal rights, violate any Intellectual Property Rights of DocMaster or any third party, publish or distribute any material unlawful, obscene or defamatory on the website, perpetrate any fraud and any other act prohibited by the law.</p>

                                <p className="text-15 text-black text-justify"><strong>Voluntary Agreement of terms & conditions</strong> - The user acknowledges that they have read the terms and conditions of the DocMaster and voluntarily in agreement without duress and with full knowledge of their legal significance. They also understand the functionalities and further changes with its software releases at later stages and are fully aware of the legal and binding effect of it.</p>

                                <p className="text-15 text-black text-justify"><strong>Governing Law and Dispute Settlement</strong> - All disputes arising out of these shall be governed by and construed in accordance with the laws of India. Any dispute arising out of or in connection with this shall be finally settled by the competent courts of New Delhi, India.</p>

                                <p className="text-15 text-black text-justify"><strong>No Legal Relationship</strong> - Nothing shall be construed to create an employer- employee, principal -client or any such relationship between user of the Website and DocMaster.</p>
                                 
                              </div>
                            </div>
                          </div>

                          <div class="accordion-item" >
                            <h2
                              class="accordion-header"
                              id="flush-headingprivacyp"
                            >
                              <button
                                class="accordion-button collapsed bg-secondary-acc p-0 text-black"
                                type="button"
                                id="privacyPolicy-el"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapsePrivacyP"
                                aria-expanded="false"
                                aria-controls="flush-collapsePrivacyP"
                              >
                                <strong className="p-3">Privacy Policy</strong>
                              </button>
                            </h2>
                            <div
                              id="flush-collapsePrivacyP"
                              class="accordion-collapse collapse accordian-shadow"
                              aria-labelledby="flush-headingprivacyp"
                              data-bs-parent="#accordionplos"
                            >
                              <div class="accordion-body p-2">
                                <p className="text-left text-blue">
                                  <b className="border-b">
                                    Our Commitment to your Privacy
                                  </b>
                                </p>
                                

                                <p className="text-15 text-black text-justify">DocMaster is committed towards protecting its user’s privacy and ensuring that every visit to its website remains completely safe and secure.</p>

                                <p className="text-15 text-black text-justify">In line with our commitment to transparency, this policy details what information is collected or processed by us, this privacy policy remains applicable to paid or free users.</p>

                                <p className="text-15 text-black text-justify"><strong>Third Party</strong> - Our website may contain links to third party websites. We are not responsible for the privacy policy or the practices of such third parties. This may include any payment gateway service portals or websites advertised on our platform. At all times, you are free to choose what information you share or save with these third parties without any notice to us.</p>

                                <p className="text-15 text-black text-justify">We may however, collect, store and share aggregate and statistical data about user traffic, analytics or trends etc. without any specific reference.</p>

                                <p className="text-15 text-black text-justify">We may partner with third party advertising networks, like well-known advertiser Google Adwords etc, to deal with our publicising on different platforms. Our website and advertising network may use cookies to gather non-personally identifiable information about your activities on this and other web destinations, to give you focused advertising depending on your interests. If you wish not to have this data utilised, you may quit by utilising the accompanying connections, for example, Google's Opt-out etc. or by setting your systems secure from such actions.</p>

                                <p className="text-15 text-black text-justify"><strong>What Information We Collect</strong> - We do not have a policy to collect users data, for the purpose of using it, for any purpose other than serving our users the desired services. Depending on the plans and usage choices of our subscribers both free and paid, we offer services where nothing is stored except in the enterprise or higher versions where users opt or need to use save and edit features of the modules.</p>

                                <p className="text-15 text-black text-justify"><strong>Who we share your Personal Information with</strong> - We do not sell, exchange or lease your name, contact details or any data to any other person. We may use some of the information which is generic or public in nature meant to generate statistical information or Artificial Intelligence or to improve product’s experience, efficiency and productivity of our users.</p>

                                <p className="text-15 text-black text-justify">Though the following paragraph stands null in normal circumstances but being added for general and for exceptional circumstances, that DocMaster would not deliver user’s data of any nature to a third party with only exception, if it is legally necessary in line with the reporting standards of the Country, by a Court order, on a Court request, or Court summon. These are the information, generally financials, about the number regarding enlisted clients, number of interesting guests, and the pages most often perused.</p>

                                <p className="text-15 text-black text-justify"><strong>Servers</strong> - DocMaster uses cloud services on third party servers. We are committed to use the best of the methods to keep all the data and servers safe, and communicate in encrypted modes always. Multi layer security systems are deployed.</p>

                                <p className="text-15 text-black text-justify"><strong>Usage and Privacy of Information</strong> - The data you give when you prepare a document or perform an activity on our website, the same is held carefully classified or kept confidential.</p>
                                 
                              </div>
                            </div>
                          </div>

                          <div class="accordion-item">
                            <h2
                              class="accordion-header"
                              id="flush-headingIprprivacyp"
                            >
                              <button
                                class="accordion-button collapsed bg-secondary-acc p-0 text-black"
                                type="button"
                                id="ipr-el"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapsePrivacyIpr"
                                aria-expanded="false"
                                aria-controls="flush-collapsePrivacyIpr"
                              >
                                <strong className="p-3"> 
                                  Intellectual Property Rights (IPR) and
                                  Copyright Policy
                                </strong>
                              </button>
                            </h2>
                            <div
                              id="flush-collapsePrivacyIpr"
                              class="accordion-collapse collapse accordian-shadow"
                              aria-labelledby="flush-headingIprprivacyp"
                              data-bs-parent="#accordionplos"
                            >
                              <div class="accordion-body p-2">
                                <p className="text-15 text-black text-justify">This Intellectual Property Rights (IPR) and Copyright Policy outlines how intellectual property, including copyrights, trademarks, and other proprietary rights are managed on DocMaster ("The Website"). By using “The Website”, you acknowledge and agree to the terms outlined below.</p>

                                <p className="text-15 text-black text-justify">Ownership of Intellectual Property - All content and materials available on DocMaster including but not limited to text, designs, graphics, logos, icons, software, documents, templates, and other resources (collectively, "Content"), are the exclusive property of DocMaster, its associates or its licensors unless otherwise expressly defined. The Contents of all types are protected by copyright, trademark, and other intellectual property laws.</p>

                                <p className="text-15 text-black text-justify">Except for the purpose and mutual written terms for the use of “The Website” subscribed, no one can reproduce, distribute, modify, display, perform, or transmit any content without the prior written permission of DocMaster or the respective intellectual property holders.</p>

                                <p className="text-15 text-black text-justify">Copyright Infringement and DMCA Policy - DocMaster respects the intellectual property rights of others and expects our users to do the same. If you believe that any content on “The Website” infringes any one’s copyright or intellectual property rights, you may submit a notification under the Digital Millennium Copyright Act (DMCA) or equivalent legislation. The team DocMaster will ensure to check the information and to take necessary corrective measures wherever required.</p>

                                <p className="text-15 text-black text-justify">The notification such made to be sent to info@mydocmaster.comand must be in detail including identification of the material that is claimed to be infringing or the subject of infringing activity and that is to be removed or access to which is to be disabled, and information reasonably sufficient to permit us to locate the material. Sender’s contact information, including your name, address,</p>

                                <p className="text-15 text-black text-justify">Upon receipt of notification, DocMaster will take appropriate steps within a period of 60 days.</p>

                                <p className="text-15 text-black text-justify">Prohibitions to use Content - Using any of the Content from DocMaster for commercial purposes, Creating derivative works from the Content. Distributing, reselling, or sublicensing the Content in any manner inconsistent with these Terms or applicable law without prior written consent are strictly prohibited.</p>

                                <p className="text-15 text-black text-justify">Third-Party Intellectual Property - DocMaster respects the intellectual property rights of all. The content available on the Website, if sourced from third-party creators or services, all efforts are made to attribute the content to its rightful owner and abide by the licensing terms. If you notice that any third-party intellectual property has been used without proper attribution or permission, please notify us immediately to help rectify the mistake.</p>

                                <p className="text-15 text-black text-justify">Modifications to the Policy - DocMaster reserves the right to modify this IPR and Copyright Policy at any time. Any changes will be effective immediately upon posting to “The Website”. It is your responsibility to review this policy periodically to remain informed about updates.</p>

                                <p className="text-15 text-black text-justify">If you have any questions or concerns regarding this IPR and Copyright Policy, Please contact <a href="mailto:info@mydocmaster.com">info@mydocmaster.com</a></p>
                                                                
                              </div>
                            </div>
                          </div>

                          <div class="accordion-item">
                            <h2
                              class="accordion-header"
                              id="flush-headingcancelPolicy"
                            >
                              <button
                                class="accordion-button collapsed bg-secondary-acc p-0  text-black"
                                type="button"
                                id="cpolicy-el"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseCancelPolicy"
                                aria-expanded="false"
                                aria-controls="flush-collapseCancelPolicy"
                              >
                                <strong className="p-3">Cancellation & Refund Policy</strong>
                              </button>
                            </h2>
                            <div
                              id="flush-collapseCancelPolicy"
                              class="accordion-collapse collapse accordian-shadow"
                              aria-labelledby="flush-headingcancelPolicy"
                              data-bs-parent="#accordionplos"
                            >
                              <div class="accordion-body p-2">
                                <p className="text-16 text-justify text-black">At DocMaster we aim to extend the best of the services to meet your professional requirements. We do not have any refund policy except as with only a few of the exceptions. One of them is technical. If you experience ongoing technical issues that prevent you from accessing the services and our support team is unable to resolve the problem within a reasonable time frame. The other is service disruption where a significant, extended disruption of services by DocMaster and you are unable to access your account for a prolonged period.</p>

                                <p className="text-16 text-justify text-black"><strong></strong> - If you choose to cancel your subscription or downgrade your plan, no refunds or credits will be given for any unused portion of the subscription. You will have access to the services until the end of the billing period you paid for.</p>

                                <p className="text-16 text-justify text-black">All refund requests are subject to review and approval by our team. If approved, the refund will be issued to the original payment method used.</p>

                                <p className="text-16 text-justify text-black"><strong>Termination by DocMaster</strong> - DocMaster reserves the right to suspend or terminate any account at any time if we suspect misuse of any nature including illegitimate use or violations of our Terms and Conditions. In such cases, no refunds will be eligible for the remaining subscription period.</p>
                                                                
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="w-100">
                 <Footer/>
                 
              </div>
            </div>
          </div>
        </div>
      </div>
    </Suspense>
  );
};

export default Home;
